import React, { useContext } from 'react'
import { useHistory } from 'react-router'
import MessageContext from 'shared/components/context/message'
import { fitToSize } from 'shared/util/sizing'
import { createGlobalStyle } from 'styled-components'
import { DEFAULT_TAGS, DEFAULT_WIDTH } from '..'
import { BACKDROP_CREATION_LOCATIONS } from '../../finalize/upload/constants'
import { STICKERS, ZOOM_MAKER } from '../../route'
import { ZoomMakerFile, ZoomMakerProps } from '../types'
import BackgroundVideo from './components/background-video'
import Footer from './components/footer'
import Intro from './components/intro'
import { ZoomMakerWelcomeContext } from './context'
import Starters from './starters'

const FullWidth = createGlobalStyle`
    body {
        width: 100%;
    }
    #header {
        width: 100vw;
    }
`

const ZoomMakerWelcome = ({
    apiKey,
    submitUrl,
    featuredStickers,
    resetCreationTool,
    setCurrentFilter,
    updateCreationTool,
    setCreationLocation,
}: ZoomMakerProps) => {
    const { sendMessage } = useContext(MessageContext)
    const { push } = useHistory()

    const onError = (error: string) => {
        sendMessage(error, 'error')
    }
    const onFileAccepted = () => {}

    const onPreviewReady = (files: ZoomMakerFile[]) => {
        const [file] = files.map(({ ...f }) => {
            const { width, height } = fitToSize(f.width, f.height, DEFAULT_WIDTH)
            f.width = width
            f.height = height
            return f
        })

        // reset creation tool data
        resetCreationTool()
        setCurrentFilter({})
        updateCreationTool({
            apiKey,
            defaultTags: DEFAULT_TAGS,
            featuredStickers,
            submitUrl,
            file,
        })

        const creationLocation = file.isStarter ? 'CREATE' : 'UPLOAD'
        setCreationLocation(BACKDROP_CREATION_LOCATIONS[creationLocation])

        window && window.scroll(0, 0)
        push(`${ZOOM_MAKER}${STICKERS}`)
    }

    return (
        <ZoomMakerWelcomeContext.Provider
            value={{
                onError,
                onFileAccepted,
                onPreviewReady,
            }}
        >
            <FullWidth />
            <BackgroundVideo />
            <Intro />
            <Starters />
            <Footer />
        </ZoomMakerWelcomeContext.Provider>
    )
}

export default ZoomMakerWelcome
